// extracted by mini-css-extract-plugin
export default {"container":"lr-z","brandName":"mr-z","productName":"nr-z","productNamePdpEnhancements":"or-z","breakLongProductName":"pr-z"};